import Vue from 'vue';
import store from "@/store";

export default {
    get: (employeeId) => {
        return Vue.axios.get(`/api/${store.state.tenantId}/employeeCompliance/${employeeId}`)
            .then(resp => resp.data);
    },
};